(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-guides-default"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Table of contents
  var body = document.getElementById('article-body');
  var tocBox = document.getElementById('toc-box');
  if (body && tocBox) {
    var headings = body.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocBox.style.display = 'none';
    } else {
      headings.forEach(function(heading, i) {
        var id = 'section-' + (i + 1);
        heading.id = id;
        var num = String(i + 1).padStart(2, '0');
        var link = document.createElement('a');
        link.href = '#' + id;
        link.className = 'toc-link';
        link.innerHTML = '<span class="toc-num">' + num + '</span>' + heading.textContent;
        tocBox.appendChild(link);
      });
    }
  }

  // Product carousels
  document.querySelectorAll('.rp-carousel-track-wrap').forEach(function(wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (!track) return;

    function getSlideWidth() {
      var slide = track.querySelector('.rp-carousel-slide');
      if (!slide) return 0;
      return slide.offsetWidth + 20;
    }

    function updateButtons() {
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
    }

    if (prev) {
      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getSlideWidth() * 2, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function() {
        track.scrollBy({ left: getSlideWidth() * 2, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Table of contents
  var body = document.getElementById('article-body');
  var tocBox = document.getElementById('toc-box');
  if (body && tocBox) {
    var headings = body.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocBox.style.display = 'none';
    } else {
      headings.forEach(function(heading, i) {
        var id = 'section-' + (i + 1);
        heading.id = id;
        var num = String(i + 1).padStart(2, '0');
        var link = document.createElement('a');
        link.href = '#' + id;
        link.className = 'toc-link';
        link.innerHTML = '<span class="toc-num">' + num + '</span>' + heading.textContent;
        tocBox.appendChild(link);
      });
    }
  }

  // Product carousels
  document.querySelectorAll('.rp-carousel-track-wrap').forEach(function(wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (!track) return;

    function getSlideWidth() {
      var slide = track.querySelector('.rp-carousel-slide');
      if (!slide) return 0;
      return slide.offsetWidth + 20;
    }

    function updateButtons() {
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
    }

    if (prev) {
      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getSlideWidth() * 2, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function() {
        track.scrollBy({ left: getSlideWidth() * 2, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-buyers-guide"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Topic accordions
  document.querySelectorAll('.bg-topic-head').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.bg-topic');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // Live article search
  var searchInput = document.getElementById('bg-search-input');
  if (!searchInput) return;

  var noResultsEl = document.getElementById('bg-search-no-results');

  searchInput.addEventListener('input', function() {
    var term = this.value.trim().toLowerCase();
    var items = document.querySelectorAll('[data-search-item]');
    var visibleCount = 0;

    items.forEach(function(item) {
      if (!term || term.length < 2) {
        item.style.display = '';
        visibleCount++;
        return;
      }
      var title = item.getAttribute('data-title') || '';
      var excerpt = item.getAttribute('data-excerpt') || '';
      var match = title.indexOf(term) !== -1 || excerpt.indexOf(term) !== -1;
      item.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    if (noResultsEl) {
      noResultsEl.style.display = (term.length >= 2 && visibleCount === 0) ? 'block' : 'none';
    }

    // Prevent form submit on short terms, allow on Enter with 2+ chars
    searchInput.form.onsubmit = function(e) {
      if (searchInput.value.trim().length < 2) {
        e.preventDefault();
      }
    };
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCatSwipers() {
    document.querySelectorAll('.js-cat-swiper:not(.swiper-initialized)').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        navigation: {
          prevEl: el.querySelector('.cat-swiper__btn--prev'),
          nextEl: el.querySelector('.cat-swiper__btn--next')
        },
        breakpoints: {
          // slidesPerView repeated at every breakpoint — same latent bug
          // as memories-swiper.liquid (see its comment / build-instructions/
          // HISTORY.md "Swiper Initialisation Fix"): Swiper 11 can fall
          // back to its own default (1) on a resize recalculation if it's
          // relying on the top-level value alone.
          768: { slidesPerView: 'auto', spaceBetween: 20 },
          1200: { slidesPerView: 'auto', spaceBetween: 28 }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCatSwipers);
  } else {
    initCatSwipers();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  const moreBtn = document.getElementById('col-hero-more');
  const description = document.getElementById('col-hero-description');
  if (moreBtn && description) {
    const syncVisibility = function() {
      moreBtn.style.display = description.scrollHeight <= description.clientHeight + 1 ? 'none' : '';
    };
    moreBtn.addEventListener('click', function() {
      const isOpen = description.classList.toggle('is-open');
      moreBtn.setAttribute('aria-expanded', isOpen);
      moreBtn.textContent = isOpen ? moreBtn.dataset.lessLabel : moreBtn.dataset.moreLabel;
    });
    syncVisibility();
    window.addEventListener('resize', syncVisibility);
    window.addEventListener('load', syncVisibility);
  }
})();

(function() {
  const sidebar = document.getElementById('col-sidebar');
  const grid = document.getElementById('col-product-grid');
  const sortSelect = document.getElementById('col-sort');
  const filterToggle = document.getElementById('col-filter-toggle');

  if (!sidebar || !grid) return;

  const collectionUrl = sidebar.dataset.collectionUrl;

  function getActiveTags() {
    return Array.from(sidebar.querySelectorAll('.filter-checkbox:checked')).map(cb => cb.value);
  }

  function buildUrl(tags, sortBy) {
    let url = collectionUrl;
    if (tags.length > 0) {
      url += '/' + tags.join('+');
    }
    const params = new URLSearchParams();
    if (sortBy && sortBy !== sortSelect.dataset.defaultSort) {
      params.set('sort_by', sortBy);
    }
    const qs = params.toString();
    if (qs) url += '?' + qs;
    return url;
  }

  async function applyFilters() {
    const tags = getActiveTags();
    const sortBy = sortSelect ? sortSelect.value : '';
    const url = buildUrl(tags, sortBy);

    grid.classList.add('is-loading');
    history.pushState(null, '', url);

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('col-product-grid');
      if (newGrid) {
        grid.innerHTML = newGrid.innerHTML;
      }
    } catch (e) {
      window.location.href = url;
    } finally {
      grid.classList.remove('is-loading');
    }
  }

  sidebar.addEventListener('change', function(e) {
    if (e.target.classList.contains('filter-checkbox')) {
      const label = e.target.closest('.filter-opt');
      const box = label ? label.querySelector('.filter-box') : null;
      if (box) {
        if (e.target.checked) {
          box.classList.add('on');
          label.classList.add('filter-opt--active');
        } else {
          box.classList.remove('on');
          label.classList.remove('filter-opt--active');
        }
      }
      applyFilters();
    }
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', applyFilters);
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', function() {
      const open = sidebar.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open);
      filterToggle.textContent = open
        ? filterToggle.dataset.hideLabel
        : filterToggle.dataset.showLabel;
    });
  }

  window.addEventListener('popstate', function() {
    window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      this.setAttribute('aria-expanded', !isOpen);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // Mobile nav
  var burger = document.querySelector('.header__burger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileOverlay = mobileNav && mobileNav.querySelector('.mobile-nav__overlay');
  var mobileClose = mobileNav && mobileNav.querySelector('.mobile-nav__close');

  function openNav() {
    mobileNav.classList.add('is-open');
    mobileNav.removeAttribute('aria-hidden');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', openNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeNav);
  if (mobileClose) mobileClose.addEventListener('click', closeNav);

  // Cart drawer
  var cartTrigger = document.getElementById('cart-drawer-trigger');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = cartDrawer && cartDrawer.querySelector('.cart-drawer__overlay');
  var cartClose = cartDrawer && cartDrawer.querySelector('.cart-drawer__close');
  var cartBody = document.getElementById('cart-drawer-body');
  var cartFooter = document.getElementById('cart-drawer-footer');
  var cartCount = document.getElementById('cart-count');

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCart(cart) {
    var strings = {
      empty: cartDrawer.dataset.empty,
      subtotal: cartDrawer.dataset.subtotal,
      viewCart: cartDrawer.dataset.viewCart,
      checkout: cartDrawer.dataset.checkout
    };
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">' + strings.empty + '</p>';
      cartFooter.innerHTML = '';
      return;
    }
    cartBody.innerHTML = cart.items.map(function(item) {
      var img = item.featured_image
        ? '<img src="' + item.featured_image.url + '" alt="' + (item.featured_image.alt || '') + '" width="72" height="72" loading="lazy">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__variant">' + item.variant_title + '</span>'
        : '';
      return '<div class="cart-drawer__item">'
        + '<a href="' + item.url + '" class="cart-drawer__item-img">' + img + '</a>'
        + '<div class="cart-drawer__item-info">'
        + '<div class="cart-drawer__item-top">'
        + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
        + '<button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="Remove item">&#10005;</button>'
        + '</div>'
        + variant
        + '<div class="cart-drawer__item-meta">'
        + '<span class="cart-drawer__item-qty">Qty: ' + item.quantity + '</span>'
        + '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>'
        + '</div>'
        + '</div>'
        + '</div>';
    }).join('');
    cartFooter.innerHTML = '<div class="cart-drawer__subtotal"><span>' + strings.subtotal + '</span><span>' + formatMoney(cart.total_price) + '</span></div>'
      + '<a href="/cart" class="cart-drawer__view-cart">' + strings.viewCart + '</a>'
      + '<a href="/checkout" class="cart-drawer__checkout">' + strings.checkout + '</a>';
  }

  function openCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        if (cartCount) cartCount.textContent = '(' + cart.item_count + ')';
        cartDrawer.classList.add('is-open');
        cartDrawer.removeAttribute('aria-hidden');
        cartTrigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
  }
  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

  if (cartBody) {
    cartBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-drawer__item-remove');
      if (!btn) return;
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        if (cartCount) cartCount.textContent = '(' + cart.item_count + ')';
      });
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (mobileNav && mobileNav.classList.contains('is-open')) closeNav();
      if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    }
  });

  window.FriarHouse = window.FriarHouse || {};
  window.FriarHouse.openCartDrawer = openCartDrawer;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memories-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMemSwiper() {
    document.querySelectorAll('.js-mem-swiper:not(.swiper-initialized)').forEach(function (el) {
      new Swiper(el, {
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          prevEl: el.querySelector('.mem-swiper__btn--prev'),
          nextEl: el.querySelector('.mem-swiper__btn--next')
        },
        pagination: {
          el: el.querySelector('.mem-swiper__pagination'),
          clickable: true
        },
        breakpoints: {
          // slidesPerView repeated at every breakpoint, not just the top
          // level: Swiper 11 has re-triggered a fallback to its own
          // default (1) on some resize/recalculation, dropping the free-
          // scroll layout down to one full-width slide (see build-instructions/
          // HISTORY.md, "Swiper Initialisation Fix", for the same bug class
          // elsewhere in this theme). Redeclaring it here at every
          // breakpoint leaves nothing for it to fall back to.
          768: { slidesPerView: 'auto', spaceBetween: 16 },
          1200: { slidesPerView: 'auto', spaceBetween: 20 }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMemSwiper);
  } else {
    initMemSwiper();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-in"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewInSwiper() {
    document.querySelectorAll('.js-new-in-swiper:not(.swiper-initialized)').forEach(function (el) {
      var cols = el.dataset.columns;
      var isAuto = !cols || cols === 'auto';
      var n = isAuto ? null : parseInt(cols, 10);
      new Swiper(el, {
        grabCursor: true,
        slidesPerView: isAuto ? 'auto' : Math.min(n, 2),
        spaceBetween: 16,
        navigation: {
          prevEl: el.querySelector('.prod-swiper__btn--prev'),
          nextEl: el.querySelector('.prod-swiper__btn--next')
        },
        pagination: {
          el: el.querySelector('.prod-swiper__pagination'),
          clickable: true
        },
        // slidesPerView repeated at every breakpoint, isAuto branch
        // included — Swiper 11 can fall back to its own default (1) on a
        // resize recalculation if it's relying on the top-level value
        // alone (see build-instructions/HISTORY.md "Swiper Initialisation
        // Fix" for the original instance of this bug in this file).
        breakpoints: isAuto
          ? { 768: { slidesPerView: 'auto', spaceBetween: 20 }, 1200: { slidesPerView: 'auto', spaceBetween: 28 } }
          : { 768: { slidesPerView: Math.min(n, 3), spaceBetween: 20 }, 1200: { slidesPerView: n, spaceBetween: 24 } }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewInSwiper);
  } else {
    initNewInSwiper();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProdSwipers() {
    document.querySelectorAll('.js-ps-section-swiper:not(.swiper-initialized)').forEach(function (el) {
      var cols = el.dataset.columns;
      var isAuto = !cols || cols === 'auto';
      var n = isAuto ? null : parseInt(cols, 10);
      new Swiper(el, {
        grabCursor: true,
        slidesPerView: isAuto ? 'auto' : Math.min(n, 2),
        spaceBetween: 16,
        navigation: {
          prevEl: el.querySelector('.prod-swiper__btn--prev'),
          nextEl: el.querySelector('.prod-swiper__btn--next')
        },
        pagination: {
          el: el.querySelector('.prod-swiper__pagination'),
          clickable: true
        },
        // slidesPerView repeated at every breakpoint, isAuto branch
        // included — Swiper 11 can fall back to its own default (1) on a
        // resize recalculation if it's relying on the top-level value
        // alone (see build-instructions/HISTORY.md "Swiper Initialisation
        // Fix" for the original instance of this bug in this file).
        breakpoints: isAuto
          ? { 768: { slidesPerView: 'auto', spaceBetween: 20 }, 1200: { slidesPerView: 'auto', spaceBetween: 28 } }
          : { 768: { slidesPerView: Math.min(n, 3), spaceBetween: 20 }, 1200: { slidesPerView: n, spaceBetween: 24 } }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProdSwipers);
  } else {
    initProdSwipers();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ── GALLERY THUMBNAILS ─────────────────────────────────── */
  var mainImg  = document.getElementById('gallery-main-img');
  var thumbs   = document.querySelectorAll('.thumb');
  var galleryImages = [];

  thumbs.forEach(function(thumb, idx) {
    galleryImages.push({
      src:  thumb.dataset.imgSrcFull || thumb.dataset.imgSrc,
      alt:  thumb.dataset.imgAlt
    });
    thumb.addEventListener('click', function() {
      if (mainImg) {
        mainImg.src = this.dataset.imgSrc;
        mainImg.alt = this.dataset.imgAlt;
      }
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── LIGHTBOX ───────────────────────────────────────────── */
  var lightbox      = document.getElementById('prod-lightbox');
  var lightboxImg   = document.getElementById('prod-lightbox-img');
  var lightboxClose = document.getElementById('prod-lightbox-close');
  var lightboxPrev  = document.getElementById('prod-lightbox-prev');
  var lightboxNext  = document.getElementById('prod-lightbox-next');
  var lightboxCount = document.getElementById('prod-lightbox-counter');
  var currentLbIdx  = 0;

  function openLightbox(idx) {
    if (!lightbox || galleryImages.length === 0) return;
    currentLbIdx = idx;
    updateLightbox();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateLightbox() {
    var item = galleryImages[currentLbIdx];
    if (!item || !lightboxImg) return;
    lightboxImg.src = item.src;
    lightboxImg.alt = item.alt;
    if (lightboxCount) {
      lightboxCount.textContent = (currentLbIdx + 1) + ' / ' + galleryImages.length;
    }
    if (lightboxPrev) lightboxPrev.disabled = currentLbIdx === 0;
    if (lightboxNext) lightboxNext.disabled = currentLbIdx === galleryImages.length - 1;
  }

  if (lightbox) {
    var galleryMain = document.getElementById('gallery-main');
    var zoomBtn = document.getElementById('gallery-zoom-btn');

    if (galleryMain) {
      galleryMain.addEventListener('click', function(e) {
        if (e.target === zoomBtn || zoomBtn && zoomBtn.contains(e.target)) return;
        openLightbox(currentLbIdx);
      });
    }
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function() {
        var activeIdx = 0;
        thumbs.forEach(function(t, i) { if (t.classList.contains('active')) activeIdx = i; });
        openLightbox(activeIdx);
      });
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function() {
        if (currentLbIdx > 0) { currentLbIdx--; updateLightbox(); }
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', function() {
        if (currentLbIdx < galleryImages.length - 1) { currentLbIdx++; updateLightbox(); }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && currentLbIdx > 0) { currentLbIdx--; updateLightbox(); }
      if (e.key === 'ArrowRight' && currentLbIdx < galleryImages.length - 1) { currentLbIdx++; updateLightbox(); }
    });

    /* Swipe support for lightbox */
    var lbTouchX = null;
    lightbox.addEventListener('touchstart', function(e) { lbTouchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      if (lbTouchX === null) return;
      var diff = lbTouchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentLbIdx < galleryImages.length - 1) { currentLbIdx++; updateLightbox(); }
        if (diff < 0 && currentLbIdx > 0) { currentLbIdx--; updateLightbox(); }
      }
      lbTouchX = null;
    }, { passive: true });
  }

  /* ── RING SIZE SELECTOR ─────────────────────────────────── */
  var sizeGrid = document.getElementById('size-grid');
  if (sizeGrid) {
    sizeGrid.addEventListener('click', function(e) {
      var btn = e.target.closest('.size-btn');
      if (!btn) return;
      sizeGrid.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('on'); });
      btn.classList.add('on');
    });
  }

  /* ── ACCORDION ──────────────────────────────────────────── */
  var accordion = document.getElementById('prod-accordion');
  if (accordion) {
    accordion.addEventListener('click', function(e) {
      var head = e.target.closest('.acc-head');
      if (!head) return;
      var item = head.closest('.acc-item');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      head.setAttribute('aria-expanded', !isOpen);
    });
  }

  /* ── ADD TO BAG ─────────────────────────────────────────── */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = productForm.querySelector('[name="id"]').value;
      var submitBtn = productForm.querySelector('[type="submit"]');
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        if (window.FriarHouse && window.FriarHouse.openCartDrawer) {
          window.FriarHouse.openCartDrawer();
        }
      })
      .catch(function() {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      });
    });
  }

  /* ── SHARE BUTTONS ──────────────────────────────────────── */
  var shareContainer = document.querySelector('.prod-share');
  if (shareContainer) {
    var shareUrl   = shareContainer.dataset.shareUrl;
    var shareTitle = shareContainer.dataset.shareTitle;
    var shareImage = shareContainer.dataset.shareImage;

    var pinterestLink  = shareContainer.querySelector('.js-share-pinterest');
    var fbLink         = shareContainer.querySelector('.js-share-facebook');
    var instagramBtn   = shareContainer.querySelector('.js-share-instagram');
    var instagramLabel = shareContainer.querySelector('.js-instagram-label');
    var copyBtn        = shareContainer.querySelector('.js-share-copy');
    var copyLabel      = shareContainer.querySelector('.js-copy-label');

    if (pinterestLink) {
      pinterestLink.href = 'https://pinterest.com/pin/create/button/?url='
        + encodeURIComponent(shareUrl)
        + (shareImage ? '&media=' + encodeURIComponent(shareImage) : '')
        + '&description=' + encodeURIComponent(shareTitle);
    }
    if (fbLink) {
      fbLink.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl);
    }

    if (instagramBtn) {
      instagramBtn.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({ title: shareTitle, url: shareUrl }).catch(function() {});
        } else {
          navigator.clipboard.writeText(shareUrl).then(function() {
            if (instagramLabel) {
              var orig = instagramLabel.textContent;
              instagramLabel.textContent = 'Copied!';
              instagramBtn.classList.add('prod-share__btn--copied');
              setTimeout(function() {
                instagramLabel.textContent = orig;
                instagramBtn.classList.remove('prod-share__btn--copied');
              }, 2000);
            }
          }).catch(function() {});
        }
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        navigator.clipboard.writeText(shareUrl).then(function() {
          if (copyLabel) {
            var orig = copyLabel.textContent;
            copyLabel.textContent = 'Copied!';
            copyBtn.classList.add('prod-share__btn--copied');
            setTimeout(function() {
              copyLabel.textContent = orig;
              copyBtn.classList.remove('prod-share__btn--copied');
            }, 2000);
          }
        }).catch(function() {
          var ta = document.createElement('textarea');
          ta.value = shareUrl;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        });
      });
    }
  }

  /* ── SWIPERS (Collection + Recently Viewed) ─────────────── */
  function buildSwiperOptions(el) {
    var cols = el.dataset.columns;
    var isAuto = !cols || cols === 'auto';
    var n = isAuto ? null : parseInt(cols, 10);
    return {
      grabCursor: true,
      slidesPerView: isAuto ? 'auto' : Math.min(n, 2),
      spaceBetween: 16,
      navigation: {
        prevEl: el.querySelector('.prod-swiper__btn--prev'),
        nextEl: el.querySelector('.prod-swiper__btn--next')
      },
      pagination: {
        el: el.querySelector('.prod-swiper__pagination'),
        clickable: true
      },
      // slidesPerView repeated at every breakpoint, isAuto branch
      // included — Swiper 11 can fall back to its own default (1) on a
      // resize recalculation if it's relying on the top-level value alone
      // (see build-instructions/HISTORY.md "Swiper Initialisation Fix"
      // for the original instance of this bug in this file).
      breakpoints: isAuto
        ? { 768: { slidesPerView: 'auto', spaceBetween: 20 }, 1200: { slidesPerView: 'auto', spaceBetween: 28 } }
        : { 768: { slidesPerView: Math.min(n, 3), spaceBetween: 20 }, 1200: { slidesPerView: n, spaceBetween: 24 } }
    };
  }

  function initProductSwipers() {
    ['.js-coll-swiper', '.js-rv-swiper'].forEach(function(sel) {
      document.querySelectorAll(sel + ':not(.swiper-initialized)').forEach(function(el) {
        new Swiper(el, buildSwiperOptions(el));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSwipers);
  } else {
    initProductSwipers();
  }

  /* ── RECENTLY VIEWED ────────────────────────────────────── */
  var RV_KEY = 'fh_recently_viewed';
  var RV_MAX = 8;

  /* Product data is output by Liquid into a JSON script tag */
  var currentProduct = null;
  try {
    var pdEl = document.getElementById('fh-product-data');
    if (pdEl) currentProduct = JSON.parse(pdEl.textContent);
  } catch(e) {}

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RV_KEY)) || [];
    } catch(e) { return []; }
  }

  function saveRecentlyViewed(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function storeCurrentProduct() {
    if (!currentProduct) return;
    /* Never add a sold or reserved piece to the list in the first place. */
    if (!currentProduct.available || currentProduct.reserved) return;
    var list = getRecentlyViewed();
    list = list.filter(function(p) { return p.handle !== currentProduct.handle; });
    list.unshift(currentProduct);
    if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
    saveRecentlyViewed(list);
  }

  /* A product stored here can still sell or become reserved after the
     snapshot was taken — localStorage has no way to know that on its own,
     so each entry is re-checked live via Shopify's product JSON endpoint
     right before rendering. Confirmed sold/reserved products are dropped
     from the list; a network error leaves an entry as-is rather than
     hiding it (better to occasionally show a stale card than to blank
     the whole carousel over a flaky connection). */
  function checkAvailability(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(res) { if (!res.ok) throw 0; return res.json(); })
      .then(function(data) {
        var reserved = (data.tags || []).indexOf('reserved') !== -1;
        return data.available && !reserved; // confirmed true/false
      })
      .catch(function() { return null; }); // unknown — don't act on it
  }

  function buildRvCard(p) {
    var currency = (currentProduct && currentProduct.currency) || '';
    var priceStr = currency + (p.price / 100).toFixed(2);
    var safeTitle = p.title.replace(/"/g, '&quot;').replace(/</g, '&lt;');
    var safeEra   = (p.era || '').replace(/</g, '&lt;');
    return '<div class="swiper-slide prod-swiper__slide">'
      + '<a href="' + p.url + '" class="product-card">'
      + '<div class="product-card__img">'
      + (p.image ? '<img src="' + p.image + '" alt="' + safeTitle + '" loading="lazy">' : '')
      + '</div>'
      + '<div class="product-card__info">'
      + '<span class="product-card__era">' + safeEra + '</span>'
      + '<span class="product-card__name">' + safeTitle + '</span>'
      + '<span class="product-card__price">' + priceStr + '</span>'
      + '</div></a></div>';
  }

  function renderRecentlyViewed() {
    if (!currentProduct) return;
    var list = getRecentlyViewed().filter(function(p) { return p.handle !== currentProduct.handle; });
    if (list.length === 0) return;

    var rvSection = document.getElementById('recently-viewed');
    var rvList    = document.getElementById('recently-viewed-list');
    if (!rvSection || !rvList) return;

    Promise.all(list.map(function(p) {
      return checkAvailability(p.handle).then(function(ok) { return { product: p, ok: ok }; });
    })).then(function(results) {
      var fresh = results.filter(function(r) { return r.ok !== false; }).map(function(r) { return r.product; });

      /* Prune confirmed sold/reserved entries out of storage so they
         don't have to be re-checked (and briefly flash in) on every
         future product page. */
      var confirmedBad = results.filter(function(r) { return r.ok === false; });
      if (confirmedBad.length > 0) {
        saveRecentlyViewed(getRecentlyViewed().filter(function(stored) {
          return !confirmedBad.some(function(r) { return r.product.handle === stored.handle; });
        }));
      }

      if (fresh.length < 2) return;

      rvList.innerHTML = fresh.map(buildRvCard).join('');
      rvSection.style.display = '';

      var rvSwiper = rvSection.querySelector('.js-rv-swiper');
      if (rvSwiper && !rvSwiper.classList.contains('swiper-initialized')) {
        new Swiper(rvSwiper, buildSwiperOptions(rvSwiper));
      }
    });
  }

  storeCurrentProduct();
  renderRecentlyViewed();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReviewsSwiper() {
    document.querySelectorAll('.js-reviews-swiper:not(.swiper-initialized)').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
          prevEl: el.querySelector('.reviews-swiper__btn--prev'),
          nextEl: el.querySelector('.reviews-swiper__btn--next')
        },
        pagination: {
          el: el.querySelector('.reviews-swiper__pagination'),
          clickable: true
        },
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 24 }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSwiper);
  } else {
    initReviewsSwiper();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
